import {CommonStore} from "./CommonStore";
import { DatasetStore } from "./DatasetStore";
import { TrainManageStore } from "./TrainManageStore";
import { AdvanceSettingStore } from "./AdvanceSettingStore";

export const RootStore = {
    common:new CommonStore(),
    dataset: new DatasetStore(),
    trainManage: new TrainManageStore(),
    advanceSetting: new AdvanceSettingStore()
}

